export type SpartanParallaxScrollSpeed =
  | string
  | {
      mobile: string;
      desktop: string;
    };

interface SpartanParallaxScrollOptions {
  scrollSpeed?: string;
  scrollClass?: string;
  enableTouchSpeed?: boolean;
}

export const resolveSpartanParallaxScrollSpeed = (
  scrollSpeed: SpartanParallaxScrollSpeed | undefined,
  breakpoint: 'mobile' | 'desktop'
): string | undefined => {
  if (scrollSpeed == null) return undefined;
  if (typeof scrollSpeed === 'string') return scrollSpeed;
  return scrollSpeed[breakpoint];
};

export const getSpartanParallaxScrollProps = ({
  scrollSpeed,
  scrollClass,
  enableTouchSpeed = false,
}: SpartanParallaxScrollOptions = {}): Record<string, string> | undefined => {
  if (!scrollSpeed && !scrollClass) return undefined;

  const scrollProps: Record<string, string> = {
    'data-scroll': '',
  };

  if (scrollSpeed) {
    scrollProps['data-scroll-speed'] = scrollSpeed;
  }

  if (scrollClass) {
    scrollProps['data-scroll-class'] = scrollClass;
  }

  if (enableTouchSpeed) {
    scrollProps['data-scroll-enable-touch-speed'] = '';
  }

  return scrollProps;
};
